import { Button, Container, Stack, Typography, Box, Divider, TextField, Link, FormControlLabel, Checkbox, Alert, Tabs, Tab, Switch, Card, CardContent, Select, MenuItem, FormControl, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Footer from "splash_components/Splash/CommonComponents/Footer";
import { NavigationBar } from "splash_components/Splash/CommonComponents/NavigationBar";

import CheckIcon from '@mui/icons-material/Check';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import React, { useEffect, useRef, useState } from "react";

import { useSnackbar } from "notistack";
import { initializeSentry } from "helpers/sentry"; // TODO: THIS COULD BE PROBLEMATIC
import { tSplash } from "locales/splash/cruxTranslation";
import { Trans } from "react-i18next";

const sprayWallAnnualPrice = 8;
const sprayWallMonthlyPrice = 12;
const wholeGymAnnualPrice = 40;
const wholeGymMonthlyPrice = 50;

const appDownloadUrl = "https://www.cruxapp.ca/download"

// Topography pattern (CC BY 4.0 Steve Schoger / heropatterns.com)
// Adjust fill-opacity in public/topography.svg to control visibility (currently 0.12)
const darkSectionSx = {
  backgroundColor: "primary.main",
  backgroundImage: [
    "radial-gradient(ellipse at 20% 50%, rgba(100, 140, 255, 0.15) 0%, transparent 50%)",
    "radial-gradient(ellipse at 80% 50%, rgba(0, 200, 180, 0.10) 0%, transparent 50%)",
    "url('/topography.svg')",
  ].join(", "),
}

export default function GymSplash() {
  const GYMS_ON_CRUX = [
    [
      "Coyote Rock Gym",
      "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/cc0f28a4-8e90-4380-108c-0acdba389300/largeavatar",
      "https://coyoterockgym.ca/",
      {}
    ],
    [
      "Jyväskylän Kiipeilykeskus",
      "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/e8ac6a44-9077-4095-ceeb-20bf922cc900/largeavatar",
      "https://www.xn--jyvskylnkiipeilykeskus-24be.fi/",
      { borderRadius: "50%" }
    ],
    [
      "Pursuit Climbing",
      "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/419e71c4-bd14-4041-fdfc-0668a3d0e300/largeavatar",
      "https://www.pursuitclimbing.com/",
      {}
    ],
    [
      "Touchstone Climbing",
      "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/37bc5323-f8f1-42ae-f036-4677b4ca9a00/largeavatar",
      "https://touchstoneclimbing.com/",
      {}
    ],
    [
      "University of New Hampshire",
      "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/368d6586-bd14-4ec5-e598-cd267d15d200/largeavatar",
      "https://www.unh.edu/",
      {}
    ]
  ]

  const TESTIMONIAL_1 = {
    name: "Kyra Condie",
    avatar: "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/4d4af679-c35f-46ea-b475-1531ddebca00/avatar",
    testimonial: <>Having climbed on spray walls for the majority of my training as a professional climber, I was always on the lookout for something that would make sharing and keeping track of my climbs easier.<br /> <br />The technology Climb with Crux is using is really revolutionizing this process and leaves me in awe every time I take a picture of a dense spray wall and it finds all the holds flawlessly.</>
  }

  const TESTIMONIAL_2 = {
    name: "Randy Prete",
    avatar: "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/34d446d4-9fc3-4cd0-caa4-76eb97dec900/avatar",
    testimonial: <>Our community loves using Crux! We're geeking out about the AI scan tool - amazing use of the technology, super satisfying and easy to use.
      <br /><br />
      We've tried a few different climbing apps to use with our spray wall and Crux has been the easiest to use, and the most widely adopted by members. Highly recommended!</>
  }

  const TESTIMONIAL_3 = {
    name: "Christopher S.",
    avatar: "https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/54c07c58-f39d-4dfd-8f1f-eef855baa500/avatar",
    testimonial: <>My kids and I love Crux. Unfortunately they have small arms so it's tough for them to find hard climbs with their height issue. So Crux gives them the ability to set some seriously hard climbs with their reach in mind. It's helping them get super strong!
      <br /><br />
      Huge huge huge fans of Crux. You guys nailed it.</>
  }

  const theme = useTheme();
  const textColor = theme.palette.primary.contrastText;

  const { enqueueSnackbar } = useSnackbar();

  const contactFormRef = useRef(null);
  const pricingFormRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      // Check if the URL contains #pricing
      if (window.location.hash === "#pricing" && pricingFormRef.current) {
        pricingFormRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 250)

  }, [])

  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [gymName, setGymName] = useState<string>("");
  const [gymLocation, setGymLocation] = useState<string>("");
  const [userIsStaff, setUserIsStaff] = useState<boolean>(true);
  const [termsAgreed, setTermsAgreed] = useState<boolean>(false);

  const [pricingGymTypeTabValue, setPricingGymTypeTabValue] = useState<number>(0);

  function onPricingGymTypeTabValueChange(newValue: number) {
    setPricingGymTypeTabValue(newValue);
  }

  const [annualBilling, setAnnualBilling] = useState<boolean>(true);

  const getMetaContent = (name) => {
    const meta = document.querySelector(`meta[name="${name}"]`) as any;
    return meta && meta.content;
  };

  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      initializeSentry("production");
    }
  }, []);

  function getStartedClicked() {
    pricingFormRef.current.scrollIntoView({ behavior: "smooth" });
  }

  function contactUsClicked() {
    contactFormRef.current.scrollIntoView({ behavior: "smooth" });
  }

  const csrfToken = getMetaContent('csrf-token');

  function onSignUpClicked(e) {
    const emailRegex = /.+@.+\..+/;
    if (!emailRegex.test(email)) {
      console.log("Invalid email: " + email);
      enqueueSnackbar("Please enter a valid email.", { variant: "error" });
      e.preventDefault();
      return false;
    }

    // Ensure required fields are present
    if (email.length === 0 || name.length === 0 || gymName.length === 0 || gymLocation.length === 0) {
      enqueueSnackbar("Please fill out all fields.", { variant: "error" });
      e.preventDefault();
      return false;
    }

    if (email.length > 1000 || gymName.length > 1000 || name.length > 1000 || gymLocation.length > 1000 || phone.length > 1000) {
      enqueueSnackbar("Your message is too long.", { variant: "error" });
      e.preventDefault();
      return false;
    }
  }

  return (
    <div style={{ backgroundColor: "#F4F4F1", backgroundImage: "url('/topography.svg')", userSelect: "text" }}>
      {screen.width < theme.breakpoints.values.sm ? (
        // Mobile
        <>
          <NavigationBar theme={theme} mobile />
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
              paddingTop: theme.spacing(5),
              paddingBottom: theme.spacing(5),
            }}
          >

            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
                sx={{ width: "100%" }}
              >
                <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "75px" }} alt="Crux Logo" />
                <Typography variant="h4" sx={{ textAlign: "center", textWrap: "balance" }}>
                  <b>
                    {tSplash("gyms.title")}
                  </b>
                </Typography>
              </Stack>
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {tSplash("gyms.subtitle")}
              </Typography>
              <Button
                variant="contained"
                sx={{
                  marginTop: "24px !important",
                  width: "100%",
                }}
                onClick={getStartedClicked}
              >
                {tSplash("gyms.get_started_button")}
              </Button>
            </Stack>
          </Container>
          <Box py={theme.spacing(4)} sx={{ ...darkSectionSx }}>
            <Container style={{ paddingLeft: theme.spacing(6), paddingRight: theme.spacing(6) }}>
              <Typography variant="body2" sx={{ textAlign: "center", mb: 2, fontWeight: 500, color: theme.palette.primary.contrastText, opacity: 0.7, textTransform: "uppercase", letterSpacing: "0.1em", fontSize: "0.7rem" }}>
                {tSplash("gyms.stats_banner.title")}
              </Typography>
              <Stack direction="row" justifyContent="space-around" alignItems="flex-start">
                {[
                  { value: "200+", label: tSplash("gyms.stats_banner.gyms") },
                  { value: "133K+", label: tSplash("gyms.stats_banner.climbs_set") },
                  { value: "24K+", label: tSplash("gyms.stats_banner.climbers") },
                  { value: "30+", label: tSplash("gyms.stats_banner.countries") },
                ].map((stat) => (
                  <Stack key={stat.label} direction="column" alignItems="center" spacing={0.25}>
                    <Typography variant="h5" sx={{ fontWeight: 800, color: theme.palette.primary.contrastText }}>{stat.value}</Typography>
                    <Typography variant="caption" sx={{ fontWeight: 500, color: theme.palette.primary.contrastText, opacity: 0.7 }}>{stat.label}</Typography>
                  </Stack>
                ))}
              </Stack>
            </Container>
          </Box>
          <Box
            pb={theme.spacing(5)}
            pt={theme.spacing(5)}
          >
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <video
                  src="https://assets.climbwithcrux.com/ai-demo-pretty.mp4"
                  style={{
                    maxHeight: "60vh",
                    maxWidth: "100%",
                    maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                    maskSize: "contain",
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center", marginTop: "32px !important" }}
                >
                  {tSplash("gyms.scan_walls_in_real_time_header")}
                </Typography>
                <Typography sx={{ textAlign: "center" }}>
                  {tSplash("gyms.scan_walls_in_real_time_text_1")}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: "24px !important",
                    width: "100%",
                  }}
                  onClick={getStartedClicked}
                >
                  {tSplash("gyms.get_started_button")}
                </Button>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(5)} pt={theme.spacing(5)} sx={{ ...darkSectionSx }} >
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                >
                  <video
                    src="https://assets.climbwithcrux.com/create-spray-wall.mp4"
                    style={{
                      maxHeight: "60vh",
                      maxWidth: "100%",
                      maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                      maskSize: "contain",
                    }}
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                  <Typography
                    variant="h5"
                    sx={{ textAlign: "center", marginTop: "32px !important" }}
                    color={textColor}
                  >
                    {tSplash("gyms.spray_wall_header")}
                  </Typography>
                  <Typography sx={{ textAlign: "center" }} color={textColor}>
                    {tSplash("gyms.spray_wall_text_1")}
                  </Typography>
                </Stack>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(3)} pt={theme.spacing(5)}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <video
                  src="https://assets.climbwithcrux.com/browse-climbs.mp4"
                  style={{
                    maxHeight: "60vh",
                    maxWidth: "100%",
                    maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                    maskSize: "contain",
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />

                <Typography
                  variant="h5"
                  sx={{ textAlign: "center", marginTop: "32px !important" }}
                >
                  {tSplash("gyms.engage_retain_header")}
                </Typography>
                <Typography sx={{ textAlign: "center" }}>
                  {tSplash("gyms.engage_retain_text_1")}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: "24px !important",
                    width: "100%",
                  }}
                  onClick={getStartedClicked}
                >
                  {tSplash("gyms.get_started_button")}
                </Button>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(5)} pt={theme.spacing(5)} sx={{ ...darkSectionSx }} >
            <Container
              style={{
                paddingLeft: theme.spacing(0),
                paddingRight: theme.spacing(0),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center" }}
                  color={textColor}
                >
                  {tSplash("common.testimonials.title")}
                </Typography>
                <Stack direction="row" width="100%" spacing={2}>
                  <Stack
                    width="100%"
                    direction="row"
                    spacing={3}
                    sx={{
                      overflow: "scroll",
                      paddingBottom: "8px",
                      // Snap scroll
                      scrollSnapType: "x mandatory",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                    }}
                  >
                    <Stack direction="column" alignItems="center" sx={{
                      borderRadius: "16px",
                      backgroundColor: "white",
                      minWidth: "calc(100% - 82px)",
                      padding: theme.spacing(4),
                      // Give it some good shadow
                      marginLeft: "32px",
                      boxShadow: "3px 6px 6px rgba(0, 0, 0, 0.45)",
                      scrollSnapAlign: "center",
                      scrollSnapStop: "always",
                      boxSizing: "border-box"
                    }}>
                      <img
                        src={TESTIMONIAL_1.avatar}
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          objectFit: "cover"
                        }}
                        alt={TESTIMONIAL_1.name}
                      />
                      <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        {TESTIMONIAL_1.name}
                      </Typography>
                      <Typography variant="body2" color="#666666" mt={-0.5} textAlign="center">
                        {tSplash("common.testimonials.kyra_title")}
                      </Typography>

                      <Stack direction="row" mt={2}>
                        <Box sx={{ minWidth: "18px" }}>
                          <Typography variant="body2" sx={{
                            fontWeight: "700",
                            fontSize: "2rem",
                            color: "#444444",
                            fontStyle: "italic"
                          }}>
                            “
                          </Typography>
                        </Box>
                        <Typography variant="body2" color="#444444" mt={1} mb={1} pl={0.5}>
                          {TESTIMONIAL_1.testimonial}
                        </Typography>
                        <Stack
                          justifyContent="flex-end">
                          <Typography variant="body2" sx={{
                            fontWeight: "700",
                            fontSize: "2rem",
                            color: "#444444",
                            fontStyle: "italic",
                            lineHeight: 0,
                            marginRight: "6px"
                          }}>
                            ”
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack direction="column" alignItems="center" sx={{
                      borderRadius: "16px",
                      backgroundColor: "white",
                      minWidth: "calc(100% - 82px)",
                      padding: theme.spacing(4),
                      // Give it some good shadow
                      boxShadow: "3px 6px 6px rgba(0, 0, 0, 0.45)",
                      scrollSnapAlign: "center",
                      scrollSnapStop: "always",
                      boxSizing: "border-box"
                    }}>
                      <img
                        src={TESTIMONIAL_2.avatar}
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          objectFit: "cover"
                        }}
                        alt={TESTIMONIAL_2.name}
                      />
                      <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        {TESTIMONIAL_2.name}
                      </Typography>
                      <Typography variant="body2" color="#666666" mt={-0.5} textAlign="center">
                        {tSplash("common.testimonials.randy_title")}
                      </Typography>

                      <Stack direction="row" mt={2}>
                        <Box sx={{ minWidth: "18px" }}>
                          <Typography variant="body2" sx={{
                            fontWeight: "700",
                            fontSize: "2rem",
                            color: "#444444",
                            fontStyle: "italic"
                          }}>
                            “
                          </Typography>
                        </Box>
                        <Typography variant="body2" color="#444444" mt={1} mb={1} pl={0.5}>
                          {TESTIMONIAL_2.testimonial}
                        </Typography>
                        <Stack
                          justifyContent="flex-end">
                          <Typography variant="body2" sx={{
                            fontWeight: "700",
                            fontSize: "2rem",
                            color: "#444444",
                            fontStyle: "italic",
                            lineHeight: 0,
                            marginRight: "6px"
                          }}>
                            ”
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack direction="column" alignItems="center" sx={{
                      borderRadius: "16px",
                      backgroundColor: "white",
                      minWidth: "calc(100% - 82px)",
                      padding: theme.spacing(4),
                      // Give it some good shadow
                      marginRight: "32px !important",
                      boxShadow: "3px 6px 6px rgba(0, 0, 0, 0.45)",
                      scrollSnapAlign: "center",
                      scrollSnapStop: "always",
                      boxSizing: "border-box"
                    }}>
                      <img
                        src={TESTIMONIAL_3.avatar}
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          objectFit: "cover"
                        }}
                        alt={TESTIMONIAL_3.name}
                      />
                      <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        {TESTIMONIAL_3.name}
                      </Typography>
                      <Typography variant="body2" color="#666666" mt={-0.5} textAlign="center">
                        {tSplash("common.testimonials.christopher_title")}
                      </Typography>

                      <Stack direction="row" mt={2}>
                        <Box sx={{ minWidth: "18px" }}>
                          <Typography variant="body2" sx={{
                            fontWeight: "700",
                            fontSize: "2rem",
                            color: "#444444",
                            fontStyle: "italic"
                          }}>
                            “
                          </Typography>
                        </Box>
                        <Typography variant="body2" color="#444444" mt={1} mb={1} pl={0.5}>
                          {TESTIMONIAL_3.testimonial}
                        </Typography>
                        <Stack
                          justifyContent="flex-end">
                          <Typography variant="body2" sx={{
                            fontWeight: "700",
                            fontSize: "2rem",
                            color: "#444444",
                            fontStyle: "italic",
                            lineHeight: 0,
                            marginRight: "6px"
                          }}>
                            ”
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Container>
          </Box>
          <Box
            pb={theme.spacing(7)}
            pt={theme.spacing(0)}
          >
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
              ref={pricingFormRef}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                mb={2}
              >
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center", marginTop: "32px !important" }}
                >
                  {tSplash("gyms.pricing.title")}
                </Typography>
              </Stack>
              <Stack direction="row" width="100%" sx={{ mb: 2 }}>
                <FormControl fullWidth>
                  <Select
                    value={pricingGymTypeTabValue}
                    onChange={(e) => onPricingGymTypeTabValueChange(e.target.value as number)}
                    sx={{ minWidth: 200 }}
                  >
                    <MenuItem value={0}>{tSplash("gyms.pricing.commercial_gyms")}</MenuItem>
                    <MenuItem value={1}>{tSplash("gyms.pricing.home_walls")}</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
              {pricingGymTypeTabValue == 0 && (
                <Stack direction="column" width="100%" p={3} boxSizing="border-box" sx={{
                  borderWidth: "1px",
                  borderColor: "divider",
                  borderStyle: "solid",
                  borderRadius: "16px"
                }}>
                  <Chip label={tSplash("gyms.pricing.free_trial_badge")} size="small" sx={{ alignSelf: "flex-start", mb: 1, backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: 600 }} />
                  <Typography variant="h5" fontWeight={400}>
                    {tSplash("gyms.pricing.spray_wall_plan.title")}
                  </Typography>
                  <Typography variant="body2" height="72px">
                    {tSplash("gyms.pricing.spray_wall_plan.description")}
                  </Typography>
                  <Typography variant="h4">
                    ${annualBilling ? sprayWallAnnualPrice : sprayWallMonthlyPrice}
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {tSplash("gyms.pricing.spray_wall_plan.price_subtitle")}
                  </Typography>
                  <Link href={appDownloadUrl} target="_blank">
                    <Button variant="contained" fullWidth sx={{ height: "56px", mt: 2 }}>
                      {tSplash("gyms.pricing.spray_wall_plan.button_text")}
                    </Button>
                  </Link>
                  <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                    <Link onClick={contactUsClicked}>
                      {tSplash("gyms.pricing.spray_wall_plan.button_sub_link")}
                    </Link>
                  </Stack>
                  <Stack direction="column" spacing={1} mt={4}>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        <Trans i18nKey="frontend.splash.gyms.pricing.spray_wall_plan.bullet_1"
                          components={{ b1: <b /> }} />
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.spray_wall_plan.bullet_2")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.spray_wall_plan.bullet_3")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.spray_wall_plan.bullet_4")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.spray_wall_plan.bullet_5")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.spray_wall_plan.bullet_6")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.spray_wall_plan.bullet_7")}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              )}

              {pricingGymTypeTabValue == 0 && (
                <Stack direction="column" width="100%" p={3} mt={2} boxSizing="border-box" sx={{
                  borderWidth: "1px",
                  borderColor: "divider",
                  borderStyle: "solid",
                  borderRadius: "16px"
                }}>
                  <Chip label={tSplash("gyms.pricing.free_trial_badge")} size="small" sx={{ alignSelf: "flex-start", mb: 1, backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: 600 }} />
                  <Typography variant="h5" fontWeight={400}>
                    {tSplash("gyms.pricing.whole_gym_plan.title")}
                  </Typography>
                  <Typography variant="body2" height="72px">
                    {tSplash("gyms.pricing.whole_gym_plan.description")}
                  </Typography>
                  <Typography variant="h4">
                    ${annualBilling ? wholeGymAnnualPrice : wholeGymMonthlyPrice}
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {tSplash("gyms.pricing.whole_gym_plan.price_subtitle")}
                  </Typography>
                  <Link href={appDownloadUrl} target="_blank">
                    <Button variant="contained" fullWidth sx={{ height: "56px", mt: 2 }}>
                      {tSplash("gyms.pricing.whole_gym_plan.button_text")}
                    </Button>
                  </Link>
                  <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                    <Link onClick={contactUsClicked}>
                      {tSplash("gyms.pricing.whole_gym_plan.button_sub_link")}
                    </Link>
                  </Stack>
                  <Stack direction="column" spacing={1} mt={4}>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        <Trans i18nKey="frontend.splash.gyms.pricing.whole_gym_plan.bullet_1"
                          components={{ b1: <b /> }} />
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_2")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_3")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_4")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_5")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_6")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_7")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_8")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.whole_gym_plan.bullet_9")}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              )}
              {pricingGymTypeTabValue == 1 && (
                <Stack direction="column" width="100%" p={3} boxSizing="border-box" sx={{
                  borderWidth: "1px",
                  borderColor: "divider",
                  borderStyle: "solid",
                  borderRadius: "16px"
                }}>
                  <Typography variant="h5" fontWeight={400} >
                    {tSplash("gyms.pricing.home_wall_plan.title")}
                  </Typography>
                  <Typography variant="body2" height="72px">
                    {tSplash("gyms.pricing.home_wall_plan.description")}
                  </Typography>
                  <Typography variant="h4">
                    $0
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {tSplash("gyms.pricing.home_wall_plan.price_subtitle")}
                  </Typography>
                  <a href="/download">
                    <Button variant="contained" fullWidth sx={{ height: "56px", mt: 2 }}>
                      {tSplash("gyms.pricing.home_wall_plan.button_text")}
                    </Button>
                  </a>
                  <Stack direction="column" spacing={1} mt={4}>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.home_wall_plan.bullet_1")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.home_wall_plan.bullet_2")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.home_wall_plan.bullet_3")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.home_wall_plan.bullet_4")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.home_wall_plan.bullet_5")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <CheckIcon sx={{ color: "green" }} />
                      <Typography variant="body2" pt="3px">
                        {tSplash("gyms.pricing.home_wall_plan.bullet_6")}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              )}

            </Container>
          </Box>
          <Box pb={theme.spacing(5)} pt={theme.spacing(5)} sx={{ ...darkSectionSx }} >
            <Container
              style={{
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                mb={2}
              >
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center" }}
                  color={textColor}
                >
                  {tSplash("gyms.faq.title")}
                </Typography>
              </Stack>
              <Box width="100%">
                <Card sx={{ width: "100%" }}>
                  <CardContent sx={{
                    p: 2,
                    pb: "40px !important",
                    pt: "40px !important",
                    // Flip the arrow when the details element is open
                    '& div > details': {
                      marginLeft: "12px !important"
                    },
                    '& div > details[open] > summary > div > svg': {
                      transform: "rotate(180deg)",
                    },
                    '& div > details > summary > div > svg': {
                      transform: "rotate(0deg)",
                    },
                    '& div > details > p': {
                      mt: 2,
                      ml: 3,
                    }
                  }}>
                    <Stack direction="column" spacing={3} divider={<Divider />}>
                      <details>
                        {/* Disable text highlighting when you click */}
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_0")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_0")}
                        </Typography>
                      </details>
                      <details>
                        {/* Disable text highlighting when you click */}
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_1")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          <Trans i18nKey="frontend.splash.gyms.faq.answer_1_1" components={{ b1: <b />, b2: <b /> }} />
                        </Typography>
                        <Typography variant="body2">
                          <Trans i18nKey="frontend.splash.gyms.faq.answer_1_2" components={{ b1: <b />, b2: <b /> }} />
                        </Typography>
                      </details>
                      <details>
                        {/* Disable text highlighting when you click */}
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_2")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_2")}
                        </Typography>
                      </details>
                      <details>
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_3")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_3")}
                        </Typography>
                      </details>
                      <details>
                        {/* Disable text highlighting when you click */}
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_4")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_4")}
                        </Typography>
                      </details>
                      <details>
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_5")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_5_1")}
                        </Typography>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_5_2")}
                        </Typography>
                      </details>
                      <details>
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_6")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_6")}
                        </Typography>
                      </details>
                      <details>
                        <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                            <Typography variant="body1" sx={{ textWrap: "pretty" }}>
                              {tSplash("gyms.faq.question_7")}
                            </Typography>
                            {/* An arrow that flips when the details element is open */}
                            <ArrowDownwardIcon />
                          </Stack>
                        </summary>
                        <Typography variant="body2">
                          {tSplash("gyms.faq.answer_7")}
                        </Typography>
                      </details>
                    </Stack>
                  </CardContent>
                </Card>
              </Box>
            </Container>
          </Box>
          <Box
            pb={theme.spacing(7)}
            pt={theme.spacing(0)}
          >
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
                ref={contactFormRef}
              >
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center", marginTop: "32px !important" }}
                >
                  {tSplash("common.request_a_demo.title")}
                </Typography>
                <Typography sx={{ textAlign: "center" }}>
                  {tSplash("common.request_a_demo.subtitle")}
                </Typography>

                {/* Primary CTA - Download App */}
                <Button
                  variant="contained"
                  size="large"
                  href={appDownloadUrl}
                  target="_blank"
                  sx={{ mt: 3, mb: 2, px: 4, py: 2 }}
                >
                  Download App & Set Up Your Gym
                </Button>

                <Typography variant="body2" sx={{ textAlign: "center", mt: 1, mb: 3, color: 'text.secondary' }}>
                  or get help below
                </Typography>

                <form onSubmit={onSignUpClicked} method="post" action="/self_serve_gym_signup">
                  <Stack spacing={1} alignItems="center" mt={2}>
                    <TextField
                      name="name"
                      label={tSplash("common.request_a_demo.your_name")}
                      variant="outlined"
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                      required
                      fullWidth
                    />
                    <TextField
                      name="email"
                      label={tSplash("common.request_a_demo.your_email")}
                      variant="outlined"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                      required
                      fullWidth
                    />
                    <TextField
                      name="phone"
                      label={tSplash("common.request_a_demo.your_phone_number")}
                      variant="outlined"
                      value={phone}
                      onChange={(event) => setPhone(event.target.value)}
                      fullWidth
                    />
                    <TextField
                      name="gymName"
                      label={tSplash("common.request_a_demo.gym_name")}
                      variant="outlined"
                      value={gymName}
                      onChange={(event) => setGymName(event.target.value)}
                      required
                      fullWidth
                    />
                    <TextField
                      name="gymLocation"
                      label={tSplash("common.request_a_demo.gym_location")}
                      variant="outlined"
                      value={gymLocation}
                      onChange={(event) => setGymLocation(event.target.value)}
                      required
                      fullWidth
                    />
                    <Stack direction="column" width="100%">
                      <FormControlLabel control={
                        <Checkbox
                          defaultChecked
                          onChange={(e) => setUserIsStaff(e.target.checked)}
                          value={userIsStaff}
                          name="userIsStaff"
                        />
                      } label={tSplash("common.request_a_demo.i_am_owner")} />
                      <FormControlLabel control={
                        <Checkbox
                          onChange={(e) => setTermsAgreed(e.target.checked)}
                          required
                          value={termsAgreed}
                          name="termsAgreed"
                        />
                      } label={<>
                        <Trans i18nKey="frontend.splash.common.request_a_demo.i_agree_to_policy"
                          components={{
                            b1: <Link href="/terms_of_service" target="_blank" />,
                            b2: <Link href="/privacy" target="_blank" />
                          }}
                        />
                      </>} />
                    </Stack>
                    {!userIsStaff && (<Alert severity="warning" sx={{ width: "100%" }}>
                      {tSplash("common.request_a_demo.i_am_owner_warning")}
                    </Alert>)}

                    {/* Authenticity token */}
                    <input type="hidden" name="authenticity_token" value={csrfToken} />

                    <Button fullWidth variant="contained" type="submit" sx={{ mt: "24px !important" }}>
                      {tSplash("common.buttons.submit")}
                    </Button>
                  </Stack>
                </form>
              </Stack>
            </Container>
          </Box>
          <Footer theme={theme} />
        </>
      ) : (
        // Desktop
        <>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
            }}
          >
            <NavigationBar theme={theme} mobile={false} />
            <Box pt={theme.spacing(12)} pb={theme.spacing(3)}>
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
              >
                <Stack direction="row" justifyContent="center" alignItems="center">
                  <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "100px" }} alt="Crux Logo" />
                </Stack>

                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography variant="h2" sx={{ textAlign: "center", fontWeight: 900, maxWidth: "800px", textWrap: "balance" }}>
                    {tSplash("gyms.title")}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", marginTop: theme.spacing(1), maxWidth: "80%", fontWeight: 400 }}
                  >
                    {tSplash("gyms.subtitle")}
                  </Typography>
                </Stack>
                <Button
                  variant="contained"
                  sx={{
                    marginBottom: "16px !important",
                    width: "max-content"
                  }}
                  onClick={getStartedClicked}
                >
                  {tSplash("gyms.get_started_button")}
                </Button>
              </Stack>

            </Box>
          </Container>
          <Box py={theme.spacing(5)} sx={{ ...darkSectionSx }}>
            <Container style={{ paddingLeft: theme.spacing(6), paddingRight: theme.spacing(6) }}>
              <Typography variant="body2" sx={{ textAlign: "center", mb: 3, fontWeight: 500, color: theme.palette.primary.contrastText, opacity: 0.7, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.75rem" }}>
                {tSplash("gyms.stats_banner.title")}
              </Typography>
              <Stack direction="row" justifyContent="center" spacing={10}>
                {[
                  { value: "200+", label: tSplash("gyms.stats_banner.partnered_gyms") },
                  { value: "133,000+", label: tSplash("gyms.stats_banner.climbs_set") },
                  { value: "24,000+", label: tSplash("gyms.stats_banner.climbers") },
                  { value: "30+", label: tSplash("gyms.stats_banner.countries") },
                ].map((stat) => (
                  <Stack key={stat.label} direction="column" alignItems="center" spacing={0.5}>
                    <Typography variant="h4" sx={{ fontWeight: 800, color: theme.palette.primary.contrastText }}>{stat.value}</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: theme.palette.primary.contrastText, opacity: 0.7 }}>{stat.label}</Typography>
                  </Stack>
                ))}
              </Stack>
            </Container>
          </Box>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
            }}
          >
            <Box
              pb={theme.spacing(7)}
              pt={theme.spacing(7)}
            >
              <Container
                style={{
                  paddingLeft: theme.spacing(6),
                  paddingRight: theme.spacing(6),
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={6}
                >
                  <Stack direction="column" spacing={2} sx={{ width: "45%" }}>
                    <Typography variant="h3" sx={{
                      fontWeight: 700,
                      fontSize: "2rem",
                    }}>
                      {tSplash("gyms.scan_walls_in_real_time_header")}
                    </Typography>
                    <Typography variant="h6" sx={{
                      fontWeight: 400
                    }}>
                      {tSplash("gyms.scan_walls_in_real_time_text_1")}
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{
                        marginTop: theme.spacing(2),
                        width: "max-content"
                      }}
                      onClick={getStartedClicked}
                    >
                      {tSplash("gyms.get_started_button")}
                    </Button>
                  </Stack>
                  <video
                    src="https://assets.climbwithcrux.com/ai-demo-pretty.mp4"
                    style={{
                      maxHeight: "60vh",
                      maxWidth: "100%",
                      maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                      maskSize: "contain",
                    }}
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                </Stack>
              </Container>
            </Box>
          </Container>
          <Box pb={theme.spacing(7)} pt={theme.spacing(7)} sx={{ ...darkSectionSx }}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={10}
              >
                <video
                  src="https://assets.climbwithcrux.com/create-spray-wall.mp4"
                  style={{
                    maxHeight: "60vh",
                    maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                    maskSize: "contain",
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                <Stack direction="column" spacing={2} sx={{ width: "45%" }} alignItems="flex-start">
                  <Typography variant="h3" color={textColor} sx={{
                    fontWeight: 700,
                    fontSize: "2rem"
                  }}>
                    {tSplash("gyms.spray_wall_header")}
                  </Typography>
                  <Typography variant="h6" color={textColor} sx={{
                    fontWeight: 400
                  }}>
                    {tSplash("gyms.spray_wall_text_1")}
                  </Typography>
                  <Button
                    variant="outlined" // Use 'outlined' variant for a border and transparent background
                    sx={{
                      color: theme.palette.primary.main, // Sets the text color to dark blue
                      backgroundColor: 'white', // Sets the background color to white
                      borderColor: theme.palette.primary.main, // Sets the border color to dark blue
                      '&:hover': {
                        backgroundColor: "#DDDDDD", // Optional: change on hover
                        // Adjust the hover color as needed, maybe a lighter shade of blue or a very light gray to indicate interactivity
                      },
                      marginTop: theme.spacing(2),
                      width: "max-content"
                    }}
                    onClick={getStartedClicked}
                  >
                    {tSplash("gyms.get_started_button")}
                  </Button>
                </Stack>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(7)} pt={theme.spacing(7)}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={6}
              >
                <Stack direction="column" spacing={2} sx={{ width: "45%" }} alignItems="flex-start">
                  <Typography variant="h3" sx={{
                    fontWeight: 700,
                    fontSize: "2rem"
                  }}>
                    {tSplash("gyms.engage_retain_header")}
                  </Typography>
                  <Typography variant="h6" sx={{
                    fontWeight: 400
                  }}>
                    {tSplash("gyms.engage_retain_text_1")}
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: theme.spacing(2),
                      width: "max-content"
                    }}
                    onClick={getStartedClicked}
                  >
                    {tSplash("gyms.get_started_button")}
                  </Button>
                </Stack>
                <video
                  src="https://assets.climbwithcrux.com/browse-climbs.mp4"
                  style={{
                    maxHeight: "60vh",
                    maxWidth: "100%",
                    maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                    maskSize: "contain",
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              </Stack>
            </Container>
          </Box>
          <Box pb={5} pt={theme.spacing(3)}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack direction="column" alignItems="center" spacing={6}>
                <Typography variant="h3" sx={{
                  fontWeight: 700,
                  fontSize: "2rem"
                }}>
                  {tSplash("common.gyms_using_crux.title")}
                </Typography>
                <Stack direction="row" justifyContent="center" sx={{
                  overflowX: "auto",
                  marginBottom: "24px !important"
                }}>
                  <Stack direction="row" spacing={10} sx={{
                    width: "max-content"
                  }}>
                    {/* White square surrounding each logo */}
                    {GYMS_ON_CRUX.map((gym) => (
                      <Link href={gym[2] as any} target="_blank" underline="none" key={gym[0] as any} color="inherit">
                        <img src={gym[1] as any} style={{ height: "100px", ...gym[3] as any }} alt={gym[0] as any} />
                      </Link>
                    ))}
                    {/* An extra tile for "and more!" */}
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      spacing={1}
                      sx={{
                        height: "100px",
                      }}
                    >
                      <Typography variant="body1" sx={{ fontWeight: 400, textAlign: "center" }}>
                        <b>{tSplash("common.gyms_using_crux.and_more")}</b>
                      </Typography>
                    </Stack>
                  </Stack>

                </Stack>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(7)} pt={theme.spacing(7)} sx={{ ...darkSectionSx }}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={6}
              >
                <Typography variant="h3" color={textColor} sx={{
                  fontWeight: 700,
                  fontSize: "2rem"
                }}>
                  {tSplash("common.testimonials.title")}
                </Typography>
                <Stack direction="row" justifyContent="center" alignItems="baseline" spacing={6}>
                  <Stack direction="column" alignItems="center" sx={{
                    borderRadius: "16px",
                    backgroundColor: "white",
                    padding: theme.spacing(4),
                    width: "300px",
                    // Give it some good shadow
                    boxShadow: "8px 12px 12px rgba(0, 0, 0, 0.45)",
                    boxSizing: "border-box"
                  }}>
                    <img
                      src={TESTIMONIAL_1.avatar}
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                      }}
                      alt={TESTIMONIAL_1.name}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                      {TESTIMONIAL_1.name}
                    </Typography>
                    <Typography variant="body2" color="#666666" mt={-0.5}>
                      {tSplash("common.testimonials.kyra_title")}
                    </Typography>

                    <Stack direction="row" mt={2}>
                      <Box sx={{ minWidth: "18px" }}>
                        <Typography variant="body2" sx={{
                          fontWeight: "700",
                          fontSize: "2rem",
                          color: "#444444",
                          fontStyle: "italic"
                        }}>
                          “
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="#444444" mt={1} mb={1} pl={0.5}>
                        {TESTIMONIAL_1.testimonial}
                      </Typography>
                      <Stack
                        justifyContent="flex-end">
                        <Typography variant="body2" sx={{
                          fontWeight: "700",
                          fontSize: "2rem",
                          color: "#444444",
                          fontStyle: "italic",
                          lineHeight: 0,
                          marginRight: "6px"
                        }}>
                          ”
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack direction="column" alignItems="center" sx={{
                    borderRadius: "16px",
                    backgroundColor: "white",
                    padding: theme.spacing(4),
                    width: "300px",
                    boxShadow: "8px 12px 12px rgba(0, 0, 0, 0.45)",
                    boxSizing: "border-box"
                  }}>
                    <img
                      src={TESTIMONIAL_2.avatar}
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                        objectFit: "cover"
                      }}
                      alt={TESTIMONIAL_2.name}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                      {TESTIMONIAL_2.name}
                    </Typography>
                    <Typography variant="body2" color="#666666" mt={-0.5}>
                      {tSplash("common.testimonials.randy_title")}
                    </Typography>

                    <Stack direction="row" mt={2}>
                      <Box sx={{ minWidth: "18px" }}>
                        <Typography variant="body2" sx={{
                          fontWeight: "700",
                          fontSize: "2rem",
                          color: "#444444",
                          fontStyle: "italic"
                        }}>
                          “
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="#444444" mt={1} mb={1} pl={0.5}>
                        {TESTIMONIAL_2.testimonial}
                      </Typography>
                      <Stack
                        justifyContent="flex-end">
                        <Typography variant="body2" sx={{
                          fontWeight: "700",
                          fontSize: "2rem",
                          color: "#444444",
                          fontStyle: "italic",
                          lineHeight: 0,
                          marginRight: "6px"
                        }}>
                          ”
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack direction="column" alignItems="center" sx={{
                    borderRadius: "16px",
                    backgroundColor: "white",
                    padding: theme.spacing(4),
                    width: "300px",
                    boxShadow: "8px 12px 12px rgba(0, 0, 0, 0.45)",
                    boxSizing: "border-box"
                  }}>
                    <img
                      src={TESTIMONIAL_3.avatar}
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                        objectFit: "cover"
                      }}
                      alt={TESTIMONIAL_3.name}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                      {TESTIMONIAL_3.name}
                    </Typography>
                    <Typography variant="body2" color="#666666" mt={-0.5}>
                      {tSplash("common.testimonials.christopher_title")}
                    </Typography>
                    <Stack direction="row" mt={2}>
                      <Box sx={{ minWidth: "18px" }}>
                        <Typography variant="body2" sx={{
                          fontWeight: "700",
                          fontSize: "2rem",
                          color: "#444444",
                          fontStyle: "italic"
                        }}>
                          “
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="#444444" mt={1} mb={1} pl={0.5}>
                        {TESTIMONIAL_3.testimonial}
                      </Typography>
                      <Stack
                        justifyContent="flex-end">
                        <Typography variant="body2" sx={{
                          fontWeight: "700",
                          fontSize: "2rem",
                          color: "#444444",
                          fontStyle: "italic",
                          lineHeight: 0,
                          marginRight: "6px"
                        }}>
                          ”
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Container>
          </Box>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
              paddingTop: theme.spacing(7),
              paddingBottom: theme.spacing(7),
            }}
            ref={pricingFormRef}
          >
            <Stack
              direction="column"
              spacing={2}
              alignItems="center"
              width={"100%"}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  fontSize: "2rem",
                  pb: 2
                }}>
                {tSplash("gyms.pricing.title")}
              </Typography>
              <Stack direction="column" width="100%">
                <Stack direction="row" width="100%" sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs value={pricingGymTypeTabValue} onChange={(e, newValue) => onPricingGymTypeTabValueChange(newValue)}>
                    <Tab label={tSplash("gyms.pricing.commercial_gyms")} sx={{ pl: 4, pr: 4 }} />
                    <Tab label={tSplash("gyms.pricing.home_walls")} sx={{ pl: 4, pr: 4 }} />
                  </Tabs>
                  <Box flexGrow={1} />
                  {pricingGymTypeTabValue == 0 && (
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Typography
                        textAlign="center"
                        variant="body1"
                        minWidth="80px"
                        color={!annualBilling ? "inherit" : "text.secondary"}
                        sx={{
                          fontWeight: !annualBilling ? "500" : "inherit"
                        }}
                      >
                        {tSplash("gyms.pricing.monthly")}
                      </Typography>

                      <Switch sx={{
                        '> span': { color: "#004080" },
                        '> .MuiSwitch-track': { backgroundColor: "#004080" }
                      }}
                        checked={annualBilling} onChange={(e, newValue) => {
                          setAnnualBilling(newValue)
                        }} />
                      <Typography
                        textAlign="center"
                        variant="body1"
                        minWidth="80px"
                        color={annualBilling ? "inherit" : "text.secondary"}
                        sx={{
                          fontWeight: annualBilling ? "500" : "inherit"
                        }}
                      >{tSplash("gyms.pricing.annual")}</Typography>
                    </Stack>)}
                </Stack>

                <Stack direction="row" width="100%" justifyContent="center">

                  {/* Spray Wall Plan */}
                  {pricingGymTypeTabValue == 0 && (
                    <Stack direction="column" width="50%" sx={{
                      borderRight: 1,
                      borderColor: "divider",
                      p: 3,
                      pt: 6
                    }}>
                      <Chip label={tSplash("gyms.pricing.free_trial_badge")} size="small" sx={{ alignSelf: "flex-start", mb: 1, backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: 600 }} />
                      <Typography variant="h5" fontWeight={400}>
                        {tSplash("gyms.pricing.spray_wall_plan.title")}
                      </Typography>
                      <Typography variant="body2" height="72px">
                        {tSplash("gyms.pricing.spray_wall_plan.description")}
                      </Typography>
                      <Typography variant="h4">
                        ${annualBilling ? sprayWallAnnualPrice : sprayWallMonthlyPrice}
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {tSplash("gyms.pricing.spray_wall_plan.price_subtitle")}
                      </Typography>
                      <Link href={appDownloadUrl} target="_blank">
                        <Button variant="contained" fullWidth sx={{ height: "56px", mt: 2 }}>
                          {tSplash("gyms.pricing.spray_wall_plan.button_text")}
                        </Button>
                      </Link>
                      <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                        <Link onClick={contactUsClicked}>
                          {tSplash("gyms.pricing.spray_wall_plan.button_sub_link")}
                        </Link>
                      </Stack>
                      <Stack direction="column" spacing={1} mt={4}>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            <Trans i18nKey="frontend.splash.gyms.pricing.spray_wall_plan.bullet_1"
                              components={{ b1: <b /> }} />
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.spray_wall_plan.bullet_2")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.spray_wall_plan.bullet_3")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.spray_wall_plan.bullet_4")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.spray_wall_plan.bullet_5")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.spray_wall_plan.bullet_6")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.spray_wall_plan.bullet_7")}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  )}

                  {/* Whole Gym Plan */}
                  {pricingGymTypeTabValue == 0 && (
                    <Stack direction="column" width="50%" p={3} pt={6}>
                      <Chip label={tSplash("gyms.pricing.free_trial_badge")} size="small" sx={{ alignSelf: "flex-start", mb: 1, backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: 600 }} />
                      <Typography variant="h5" fontWeight={400}>
                        {tSplash("gyms.pricing.whole_gym_plan.title")}
                      </Typography>
                      <Typography variant="body2" height="72px">
                        {tSplash("gyms.pricing.whole_gym_plan.description")}
                      </Typography>
                      <Typography variant="h4">
                        ${annualBilling ? wholeGymAnnualPrice : wholeGymMonthlyPrice}
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {tSplash("gyms.pricing.whole_gym_plan.price_subtitle")}
                      </Typography>
                      <Link href={appDownloadUrl} target="_blank">
                        <Button variant="contained" fullWidth sx={{ height: "56px", mt: 2 }}>
                          {tSplash("gyms.pricing.whole_gym_plan.button_text")}
                        </Button>
                      </Link>
                      <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                        <Link onClick={contactUsClicked}>
                          {tSplash("gyms.pricing.whole_gym_plan.button_sub_link")}
                        </Link>
                      </Stack>
                      <Stack direction="column" spacing={1} mt={4}>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            <Trans i18nKey="frontend.splash.gyms.pricing.whole_gym_plan.bullet_1"
                              components={{ b1: <b /> }} />
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_2")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_3")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_4")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_5")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_6")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_7")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_8")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.whole_gym_plan.bullet_9")}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  )}

                  {/* Home wall plan */}
                  {pricingGymTypeTabValue == 1 && (
                    <Stack direction="column" width="33%" sx={{
                      borderLeft: 1,
                      borderRight: 1,
                      borderColor: "divider",
                      p: 3,
                      pt: 6
                    }}>
                      <Typography variant="h5" fontWeight={400}>
                        {tSplash("gyms.pricing.home_wall_plan.title")}
                      </Typography>
                      <Typography variant="body2" height="72px">
                        {tSplash("gyms.pricing.home_wall_plan.description")}
                      </Typography>
                      <Typography variant="h4">
                        $0
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {tSplash("gyms.pricing.home_wall_plan.price_subtitle")}
                      </Typography>
                      <a href="/download">
                        <Button variant="contained" fullWidth sx={{ height: "56px", mt: 2 }}>
                          {tSplash("gyms.pricing.home_wall_plan.button_text")}
                        </Button>
                      </a>
                      <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                        <Link href="#" style={{ opacity: 0, pointerEvents: "none" }}>
                          .
                        </Link>
                      </Stack>
                      <Stack direction="column" spacing={1} mt={4}>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.home_wall_plan.bullet_1")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.home_wall_plan.bullet_2")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.home_wall_plan.bullet_3")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.home_wall_plan.bullet_4")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.home_wall_plan.bullet_5")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" spacing={1}>
                          <CheckIcon sx={{ color: "green" }} />
                          <Typography variant="body2" pt="3px">
                            {tSplash("gyms.pricing.home_wall_plan.bullet_6")}
                          </Typography>
                        </Stack>

                      </Stack>
                    </Stack>
                  )}


                </Stack>
              </Stack>
            </Stack>

          </Container>
          <Box id="faq" pb={theme.spacing(7)} pt={theme.spacing(7)} sx={{ ...darkSectionSx }}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={6}
              >
                <Typography variant="h3" color={textColor} sx={{
                  fontWeight: 700,
                  fontSize: "2rem"
                }}>
                  Frequently asked questions
                </Typography>
                <Box width="100%">
                  <Card sx={{ width: "100%" }}>
                    <CardContent sx={{
                      p: 3,
                      pb: "40px !important",
                      pt: "40px !important",
                      // Flip the arrow when the details element is open
                      '& div > details': {
                        marginLeft: "24px !important"
                      },
                      '& div > details[open] > summary > div > svg': {
                        transform: "rotate(180deg)",
                      },
                      '& div > details > summary > div > svg': {
                        transform: "rotate(0deg)",
                      },
                      '& div > details > p': {
                        mt: 2,
                        ml: 3,
                      }
                    }}>
                      <Stack direction="column" spacing={3} divider={<Divider />}>
                        <details>
                          {/* Disable text highlighting when you click */}
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_0")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_0")}
                          </Typography>
                        </details>
                        <details>
                          {/* Disable text highlighting when you click */}
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_1")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            <Trans i18nKey="frontend.splash.gyms.faq.answer_1_1" components={{ b1: <b />, b2: <b /> }} />
                          </Typography>
                          <Typography variant="body1">
                            <Trans i18nKey="frontend.splash.gyms.faq.answer_1_2" components={{ b1: <b />, b2: <b /> }} />
                          </Typography>
                        </details>
                        <details>
                          {/* Disable text highlighting when you click */}
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_2")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_2")}
                          </Typography>
                        </details>
                        <details>
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_3")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_3")}
                          </Typography>
                        </details>
                        <details>
                          {/* Disable text highlighting when you click */}
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_4")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_4")}
                          </Typography>
                        </details>
                        <details>
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_5")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_5_1")}
                          </Typography>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_5_2")}
                          </Typography>
                        </details>
                        <details>
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_6")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_6")}
                          </Typography>
                        </details>
                        <details>
                          <summary style={{ listStyle: "none", cursor: "pointer", userSelect: "none" }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="h6" fontWeight={400}>
                                {tSplash("gyms.faq.question_7")}
                              </Typography>
                              {/* An arrow that flips when the details element is open */}
                              <ArrowDownwardIcon />
                            </Stack>
                          </summary>
                          <Typography variant="body1">
                            {tSplash("gyms.faq.answer_7")}
                          </Typography>
                        </details>
                      </Stack>
                    </CardContent>
                  </Card>


                </Box>
              </Stack>
            </Container>
          </Box>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
              paddingTop: theme.spacing(7),
              paddingBottom: theme.spacing(7),
            }}
          >
            <Stack
              direction="column"
              spacing={2}
              alignItems="center"
              ref={contactFormRef}
              width={"100%"}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  fontSize: "2rem"
                }}>
                {tSplash("common.request_a_demo.title")}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 400,
                  maxWidth: "530px",
                  textAlign: "center"
                }}>
                {tSplash("common.request_a_demo.subtitle")}
              </Typography>

              {/* Primary CTA - Download App */}
              <Button
                variant="contained"
                size="large"
                href={appDownloadUrl}
                target="_blank"
                sx={{ mt: 3, mb: 2, px: 6, py: 3, fontSize: "1.1rem" }}
              >
                Download App & Set Up Your Gym
              </Button>

              <Typography variant="body2" sx={{ textAlign: "center", mt: 1, mb: 3, color: 'text.secondary' }}>
                or get help below
              </Typography>

              <form onSubmit={onSignUpClicked} method="post" action="/self_serve_gym_signup" style={{ width: "100%", maxWidth: "530px" }}>
                <Stack direction="column" spacing={2} alignItems="center" width="100%" pl={1} pr={1}>
                  <TextField
                    name="name"
                    label={tSplash("common.request_a_demo.your_name")}
                    variant="outlined"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    required
                    fullWidth
                  />
                  <TextField
                    name="email"
                    label={tSplash("common.request_a_demo.your_email")}
                    variant="outlined"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                    fullWidth
                  />
                  <TextField
                    name="phone"
                    label={tSplash("common.request_a_demo.your_phone_number")}
                    variant="outlined"
                    value={phone}
                    onChange={(event) => setPhone(event.target.value)}
                    fullWidth
                  />
                  <TextField
                    name="gymName"
                    label={tSplash("common.request_a_demo.gym_name")}
                    variant="outlined"
                    value={gymName}
                    onChange={(event) => setGymName(event.target.value)}
                    required
                    fullWidth
                  />
                  <TextField
                    name="gymLocation"
                    label={tSplash("common.request_a_demo.gym_location")}
                    variant="outlined"
                    value={gymLocation}
                    onChange={(event) => setGymLocation(event.target.value)}
                    required
                    fullWidth
                  />
                  <Stack direction="column" width="100%">
                    <FormControlLabel control={
                      <Checkbox
                        defaultChecked
                        onChange={(e) => setUserIsStaff(e.target.checked)}
                        value={userIsStaff}
                        name="userIsStaff"
                      />
                    } label={tSplash("common.request_a_demo.i_am_owner")} />
                    <FormControlLabel control={
                      <Checkbox
                        onChange={(e) => setTermsAgreed(e.target.checked)}
                        required
                        value={termsAgreed}
                        name="termsAgreed"
                      />
                    } label={<>
                      <Trans i18nKey="frontend.splash.common.request_a_demo.i_agree_to_policy"
                        components={{
                          b1: <Link href="/terms_of_service" target="_blank" />,
                          b2: <Link href="/privacy" target="_blank" />
                        }}
                      />
                    </>} />
                  </Stack>
                  {!userIsStaff && (<Alert severity="warning" sx={{ width: "100%" }}>
                    {tSplash("common.request_a_demo.i_am_owner_warning")}
                  </Alert>)}


                  {/* Authenticity token */}
                  <input type="hidden" name="authenticity_token" value={csrfToken} />

                  <Button variant="contained" type="submit" fullWidth>
                    {tSplash("common.buttons.submit")}
                  </Button>
                </Stack>
              </form>
            </Stack>

          </Container>
          <Footer theme={theme} />
        </>
      )
      }
    </div >
  );
}
